import script from "./multiCall.vue?vue&type=script&setup=true&lang=js"
export * from "./multiCall.vue?vue&type=script&setup=true&lang=js"

import "./multiCall.vue?vue&type=style&index=0&id=c72246b4&lang=scss&scoped=true"

import exportComponent from "D:\\works\\Company项目\\桃小黑\\heitao-im\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c72246b4"]])

export default __exports__